import {Component} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UserService} from "../../../pages/shared/user/user.service";
import {ToastService} from "../../core/toast.service";

@Component({
  selector: 'app-refer-client-form',
  templateUrl: 'refer-client-form.component.html',
})
export class ReferClientFormComponent{
  form: FormGroup;

  constructor(
    fb: FormBuilder,
    private userService: UserService,
    private toast: ToastService
  ){
    this.form = fb.group({
      email: ['', Validators.required]
    })
  }

  refer(form: FormGroup){
    if(!form.valid){
      return;
    }

    this.userService.refer(form.value.email)
      .subscribe((res) => {
        this.toast.show(res.message);
      });

    form.reset();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/refer-client-form/refer-client-form.component.ts